module.exports = __webpack_public_path__ + "assets/teethFrontview.ccd9601c3732b5b5577e6e3554a80d0f.png";